/**
* =========================================================================================
* Component - Filter Icon 
* =========================================================================================
* 
**/

import React from 'react';

import { getFiltersLen, isMobileDevice } from '../../../common/function';
import { COLOR } from '../../../common/constant';
import * as Icon from 'ubs-icons';
import UPopup from "ubs-framework/v2/UPopup";

const FilterIcon = ({filters, getFilter}) => {

    return (
        <React.Fragment>
            <div className={`u_filter ${getFiltersLen(filters) >= 1 ? 'u_filter-active' : ''}`}>
                <UPopup
                    params={{ className: "u_tooltip", disabled: isMobileDevice() }}
                    desc={<span>Filters</span>}
                >
                    <span className="u_filter-btn u_filter-icon" onClick={() => getFilter(true)}>
                        <span className="u_font u_mr-3">Filter:</span>
                        <Icon.Filter fill={COLOR.u_icon_bg} size={16} />
                        {
                            getFiltersLen(filters) >= 1 && <label className="u_filter-icon-count">{getFiltersLen(filters)}</label>
                        }
                    </span>
                </UPopup>
            </div>
        </React.Fragment>
    )
}

export default FilterIcon;
